// extracted by mini-css-extract-plugin
export default {"wrapper":"TopUpPage_wrapper__ZFt68","text":"TopUpPage_text__-65ox","number":"TopUpPage_number__xvzd3"};